module.exports = __webpack_public_path__ + "img/12217_17.f3ea53e6.png";